import React from 'react';
import ReactJson from 'react-json-view';

export function JsonViewer(props) {
    return <ReactJson {...props} />;
}
